import {z} from 'zod';

import {BaseVoidResponseSchema} from '@dms/api/shared';

// PostSmallUnitMaterialApiResponseSchema
export const PostSmallUnitMaterialApiResponseSchema = z.union([
  z
    .object({
      smallUnitMaterialId: z.string(),
    })
    .nullable(),
  BaseVoidResponseSchema, // Assuming `void` means a base schema for empty response
]);

export type PostSmallUnitMaterialApiResponse = z.infer<
  typeof PostSmallUnitMaterialApiResponseSchema
>;

// PostSmallUnitMaterialApiArgSchema
export const PostSmallUnitMaterialApiArgSchema = z.object({
  body: z
    .object({
      name: z.string(),
      orderVariantIds: z.array(z.string()), // UUID array
      amountType: z.enum([
        'SMALLUNITMATERIAL_FROM_MATERIAL_LABOUR',
        'SMALLUNITMATERIAL_FROM_LABOUR',
        'SMALLUNITMATERIAL_FROM_MATERIAL',
      ]),
      amountValue: z.number(),
      isMaxValue: z.boolean(),
      maxValue: z
        .object({
          amount: z.number(),
          currency: z.string(),
        })
        .nullable()
        .optional(),
    })
    .nullable(),
});

export type PostSmallUnitMaterialApiArg = z.infer<typeof PostSmallUnitMaterialApiArgSchema>;

// GetSmallUnitMaterialApiResponseSchema
export const GetSmallUnitMaterialApiResponseSchema = z.union([
  z
    .object({
      smallUnitMaterialId: z.string(),
      name: z.string(),
      orderVariantIds: z.array(z.string()), // UUID array
      amountType: z.enum([
        'SMALLUNITMATERIAL_FROM_MATERIAL_LABOUR',
        'SMALLUNITMATERIAL_FROM_LABOUR',
        'SMALLUNITMATERIAL_FROM_MATERIAL',
      ]),
      amountValue: z.number(),
      isMaxValue: z.boolean(),
      maxValue: z
        .object({
          amount: z.number(),
          currency: z.string(),
        })
        .nullable()
        .optional(),
    })
    .nullable(),
  BaseVoidResponseSchema, // 204 void case
]);

export type GetSmallUnitMaterialApiResponse = z.infer<typeof GetSmallUnitMaterialApiResponseSchema>;

// GetSmallUnitMaterialApiArgSchema
export const GetSmallUnitMaterialApiArgSchema = z.object({
  smallUnitMaterialId: z.string(), // UUID
});

export type GetSmallUnitMaterialApiArg = z.infer<typeof GetSmallUnitMaterialApiArgSchema>;

// DeleteSmallUnitMaterialApiResponseSchema
export const DeleteSmallUnitMaterialApiResponseSchema = BaseVoidResponseSchema;

export type DeleteSmallUnitMaterialApiResponse = z.infer<
  typeof DeleteSmallUnitMaterialApiResponseSchema
>;

// DeleteSmallUnitMaterialApiArgSchema
export const DeleteSmallUnitMaterialApiArgSchema = z.object({
  smallUnitMaterialId: z.string(), // UUID
});

export type DeleteSmallUnitMaterialApiArg = z.infer<typeof DeleteSmallUnitMaterialApiArgSchema>;

// PatchSmallUnitMaterialApiResponseSchema
export const PatchSmallUnitMaterialApiResponseSchema = BaseVoidResponseSchema;

export type PatchSmallUnitMaterialApiResponse = z.infer<
  typeof PatchSmallUnitMaterialApiResponseSchema
>;

// PatchSmallUnitMaterialApiArgSchema
export const PatchSmallUnitMaterialApiArgSchema = z.object({
  smallUnitMaterialId: z.string(), // UUID
  body: z
    .object({
      name: z.string(),
      orderVariantIds: z.array(z.string()), // UUID array
      amountType: z.enum([
        'SMALLUNITMATERIAL_FROM_MATERIAL_LABOUR',
        'SMALLUNITMATERIAL_FROM_LABOUR',
        'SMALLUNITMATERIAL_FROM_MATERIAL',
      ]),
      amountValue: z.number(),
      isMaxValue: z.boolean(),
      maxValue: z
        .object({
          amount: z.number(),
          currency: z.string(),
        })
        .nullable()
        .optional(),
    })
    .nullable(),
});

export type PatchSmallUnitMaterialApiArg = z.infer<typeof PatchSmallUnitMaterialApiArgSchema>;
